'use strict';

var React = require('react'),
    TimeAgoFormatter = require('../utils/TimeAgoFormatter'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    formatDate = require('../utils/formatDate'),
    { PropTypes } = React;

var TimeAgo = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    date: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date)
    ]).isRequired,
    className: PropTypes.string
  },

  getInitialState() {
    return {
      text: this.getText()
    };
  },

  getText() {
    return this.isAbsolute() ?
      formatDate(this.props.date) :
      TimeAgoFormatter.format(this.props.date);
  },

  isAbsolute() {
    return TimeAgoFormatter.isAbsolute(this.props.date, { maxWeeks: 2 });
  },

  componentDidMount() {
    this.startCheckDate();
  },

  componentDidUpdate(prevState, prevProps) {
    if (prevProps.date !== this.props.date) {
      this.startCheckDate();
    }
  },

  componentWillUnmount() {
    this.stopCheckDate();
  },

  startCheckDate() {
    this.stopCheckDate();
    this.checkDateInterval = setInterval(this.checkDate, 3000);
    this.checkDate();
  },

  stopCheckDate() {
    clearInterval(this.checkDateInterval);
    this.checkDateInterval = null;
  },

  checkDate() {
    if (this.isAbsolute() || !this.isMounted()) {
      this.stopCheckDate();
    }

    this.setState({
      text: this.getText()
    });
  },

  render() {
    return (
      <time className={this.props.className}>
        {this.state.text}
      </time>
    );
  }
});

module.exports = TimeAgo;


/** WEBPACK FOOTER **
 ** ./organisms/TimeAgo.jsx
 **/